export default __webpack_public_path__ + "static/media/head04_zh_tw_pc@2x.62f4a66c.png";